import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";

type Props = {
  value?: string;
  label?: string;
};
type Emits = {
  (e: "input", value: string): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordField',
  props: {
    value: { default: "" },
    label: { default: "パスワード" }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string, label: string };




const modelValue = computed({
  get: () => props.value,
  set: value => emits("input", value)
});

const isPassword = ref(true);
const appendIcon = computed(() =>
  isPassword.value ? "mdi-eye-off" : "mdi-eye"
);
const type = computed(() => (isPassword.value ? "password" : "text"));

return { __sfc: true,props, emits, modelValue, isPassword, appendIcon, type }
}

})